/* global window */

const storage = window.localStorage

const setItem = (key, value) => {
  try {
    storage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.error(e)
  }
}

const getItem = (key) => {
  try {
    const item = storage.getItem(key)
    if (item === null) {
      return undefined
    }
    return JSON.parse(item)
  } catch (err) {
    return undefined
  }
}

const removeItem = (key) => {
  try {
    storage.removeItem(key)
  } catch (e) {
    console.error(e)
  }
}

export function setCurrentUser (data) {
  setItem('currentUser', data)
}

export function getCurrentUser () {
  return getItem('currentUser')
}

export function removeCurrentUser () {
  removeItem('currentUser')
}

export function setToken (token) {
  setItem('authToken', token)
}

export function getToken () {
  return getItem('authToken')
}

export function removeToken () {
  removeItem('authToken')
}

export function saveState (data) {
  setItem('reduxState', data)
}

export function loadState () {
  return getItem('reduxState')
}

export function removeState () {
  removeItem('reduxState')
}



// WEBPACK FOOTER //
// ./src/localStorage.js